import './styles.sass'
import { ReactComponent as CloseIcon } from '@/assets/icons/close-icon.svg'

export function NotificationMessageSubject ({ subject, removeNotification }) {
  return <section className="notifications-top">
    <div className="title">
      {subject}
    </div>
    <div className="close-button" onClick={() => removeNotification()}>
      <CloseIcon />
    </div>
  </section>
}
